// import { useEffect } from "react";
/* Animate On Scroll Library */
// import AOS from "aos";
// import "aos/dist/aos.css";
/* Components */
import Landing from "../views/Landing";
import Agenda from "../views/Agenda";
import Support from "../views/Support";
import About from "../views/About";

function Home() {
  return (
    <>
      <Landing title={"#wijzijndeharp"} />
      <About />
      <Agenda />
      <Support />
    </>
  );
}

export default Home;
